import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TCreditNote } from 'redux/reducers/invoiceManagement/types';

/** A credit note row: the EM name and the per-invoice values are filled in by the page. */
export type TCreditNoteRow = TCreditNote & {
	emName: string;
	invoiceNumber: string;
};

export const tableStructure: TTableStructure<keyof TCreditNoteRow, TCreditNoteRow>[] = [
	{
		/** Hidden, a row click opens the Credit Note Details. */
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.LEFT,
		key: true,
	},
	{
		name: 'EM',
		selector: 'emName',
		show: true,
		sortable: false,
		filterable: false,
		value: (item: TCreditNoteRow) => ({ id: item.emId, name: item.emName }),
		colSpan: 2,
		type: ETableStructureType.EM,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'CN Number',
		selector: 'number',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		/** The credited invoices of the credit note; also used by the Invoice Number filter. */
		name: 'Invoice Number',
		selector: 'invoiceNumber',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'CN Date',
		selector: 'createdAt',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Credited Amount',
		selector: 'crTotalAmount',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'VAT Amount',
		selector: 'crTotalVat',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		currency: () => '%',
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Processing Status',
		selector: 'processingStatus',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['pending', 'pending'],
			['credited', 'credited'],
		],
		colors: [
			['pending', 'warning.light'],
			['credited', 'success.light'],
		],
	},
	{
		name: 'Processing Method',
		selector: 'processingMethod',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['deduct', 'deduct'],
			['refund', 'refund'],
		],
		// colors: [
		// 	['deduct', 'error.light'],
		// 	['refund', 'info.light'],
		// ],
	},
	{
		name: 'Refunded Invoice ID',
		selector: 'refundedInvoiceId',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.INVOICE_NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Payment Info',
		selector: 'paymentInfo',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Comments',
		selector: 'comments',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created By',
		selector: 'createdBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
];
